import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { RUDetailedLocationService } from '../ru-detailed-location.service';
import { RUDetailedLocation } from '../ru-detailed-location';

@Component({
    selector: 'app-ru-detailed-location',
    templateUrl: './ru-detailed-location.component.html',
    styleUrls: ['./ru-detailed-location.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class RUDetailedLocationComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private rUDetailedLocationService: RUDetailedLocationService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.rUDetailedLocation = data.rUDetailedLocation,
			this.statuses = rUDetailedLocationService.statuses;
	}

	@Input() rUDetailedLocation: RUDetailedLocation;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	rUDetailedLocationId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'rUDetailedLocationId': [],
		'name': [],
		'locationId': [],
		'locationTypeId': [],
		'parentLocationId': [],
		'timeZone': [],
	};
	
	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole rUDetailedLocation object
		if (this.rUDetailedLocation) {
			this.rUDetailedLocationId = this.rUDetailedLocation.rUDetailedLocationId;
			this.fixDates();
			this.form1.patchValue(this.rUDetailedLocation);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.rUDetailedLocationId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.rUDetailedLocationService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.rUDetailedLocation = res.data.rUDetailedLocation;
						this.doAdd.emit(this.rUDetailedLocation);
					},
					(err: any) => {
						console.log('rUDetailedLocation-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('rUDetailedLocation: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.rUDetailedLocationService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.rUDetailedLocation = res.data.rUDetailedLocation;
						this.doUpdate.emit(this.rUDetailedLocation);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.rUDetailedLocationService.delete(this.rUDetailedLocation.rUDetailedLocationId)
				.subscribe(
					(res: any) => {
						console.log('rUDetailedLocation-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.rUDetailedLocation);
					},
					(err: any) => {
						console.log('rUDetailedLocation-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			rUDetailedLocationId: [this.rUDetailedLocationId],
			name: [],
			locationId: [],
			locationTypeId: [],
			parentLocationId: [],
			timeZone: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.rUDetailedLocation.rUDetailedLocationDate = moment(this.rUDetailedLocation.rUDetailedLocationDate).toDate();
	}
}
